import { GoPlus } from "react-icons/go";
import { Button } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import PositionItem from "../PositionItem";
import LeaveTypeITem from "./LeaveTypeITem";
import LeavePolicyITem from "./LeavePolicyITem";

export default ({OrgLeavePolicies, setshowaddleavepolicy }: any) => {


 
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Policy</p>
      <small>No leave policy has been added</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            {" "}
            <GoPlus size={15} className=" mx-1 inline" /> Add Policy
          </>
        }
        onBtnClick={() => {
          setshowaddleavepolicy(true);
        }}
      />
    </div>
  );

  return (<div>
  
  <div className="flex justify-between mx-3"> 
    <p className="text-textbg font-semibold text-sm mb-2 text-[16px] bg-white">
        Policy({OrgLeavePolicies.length})
      </p> 
         <Button
            width={200}
            disabled={false}
            text={  <>  <GoPlus size={15} className=" mx-1 inline" /> Add Policy  </>   }
            onBtnClick={() => {
              setshowaddleavepolicy(true);
            }}
          />
          </div>

          <div>
        {OrgLeavePolicies.length > 0 ? (
          OrgLeavePolicies.map((it: any) => <LeavePolicyITem item={it} />)
        ) : (
          <EmptyList />
        )}
      </div>
    
    
    
    </div>
  );
};
